export const AUTH_COLORS = {
    textPrimary: '#232B48',
    textSecondary: '#6C7185',
    placeholder: '#B6B9C2',
    primary: '#054CCC',
    primaryHover: '#0d4bbd',
    border: '#E7E8EB',
    borderLight: '#F4F6FE',
    tabsBg: '#EAEFFE',
    error: '#EF2D5E',
    link: '#054CCC',
};

export const authDialogPaperSx = {
    maxWidth: 500,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '24px',
    border: `1px solid ${AUTH_COLORS.borderLight}`,
    boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    maxHeight: 'calc(100dvh - 32px)',
    overflow: 'hidden',
    m: { xs: '16px', sm: 'auto' },
};

export const authDialogScrollSx = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    px: '28px',
    pt: '28px',
    pb: '28px',
};

export const authDialogTitleRowSx = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
};

export const authTitleSx = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '130%',
    color: AUTH_COLORS.textPrimary,
    flex: 1,
};

export const authLabelSx = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '130%',
    color: AUTH_COLORS.textPrimary,
    pl: '4px',
};

export const authFieldSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        height: 44,
        fontSize: 16,
        fontFamily: "'Roboto', sans-serif",
        color: AUTH_COLORS.textPrimary,
        pl: '16px',
        pr: '16px',
        py: 0,
        backgroundColor: '#FFFFFF',
        '& fieldset': {
            borderColor: AUTH_COLORS.border,
        },
        '&:hover fieldset': {
            borderColor: AUTH_COLORS.border,
        },
        '&.Mui-focused fieldset': {
            borderColor: `${AUTH_COLORS.primary} !important`,
            borderWidth: '1px',
        },
        '&.Mui-error fieldset': {
            borderColor: AUTH_COLORS.error,
        },
        '&.Mui-error.Mui-focused fieldset': {
            borderColor: `${AUTH_COLORS.error} !important`,
        },
        '& input, & .MuiOutlinedInput-input': {
            padding: '12px 0',
            height: 'auto',
            caretColor: AUTH_COLORS.primary,
            outline: 'none',
            '&::selection': {
                backgroundColor: 'rgba(5, 76, 204, 0.2)',
                color: AUTH_COLORS.textPrimary,
            },
            '&::placeholder': { color: AUTH_COLORS.placeholder, opacity: 1 },
            '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
                WebkitBoxShadow: '0 0 0 100px #FFFFFF inset',
                WebkitTextFillColor: AUTH_COLORS.textPrimary,
                caretColor: AUTH_COLORS.primary,
                transition: 'background-color 5000s ease-in-out 0s',
            },
        },
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '12px',
    },
    '& .MuiFormHelperText-root': {
        mx: 0,
        mt: '4px',
        pl: '4px',
        fontFamily: "'Roboto', sans-serif",
        fontSize: 12,
        lineHeight: '130%',
        color: AUTH_COLORS.textSecondary,
        '&.Mui-error': {
            color: AUTH_COLORS.error,
        },
    },
};

export const authPasswordFieldSx = {
    '& .MuiOutlinedInput-root.MuiInputBase-adornedEnd': {
        pr: '16px !important',
    },
    '& .MuiInputAdornment-positionEnd': {
        ml: '8px',
        mr: 0,
        height: 'auto',
        maxHeight: 'none',
        color: AUTH_COLORS.placeholder,
        '& .MuiIconButton-root': {
            margin: 0,
            color: 'inherit',
        },
        '& .MuiSvgIcon-root': {
            color: 'inherit',
        },
    },
};

export const authPrimaryButtonSx = {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 16,
    lineHeight: '127%',
    textTransform: 'none',
    backgroundColor: AUTH_COLORS.primary,
    color: '#FFFFFF',
    borderRadius: '6px',
    px: '16px',
    py: '14px',
    minHeight: 48,
    width: '100%',
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: AUTH_COLORS.primaryHover,
        boxShadow: 'none',
    },
    '&:disabled': {
        opacity: 0.5,
        color: '#FFFFFF',
        backgroundColor: AUTH_COLORS.primary,
    },
};

export const authTabsContainerSx = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    p: '4px',
    gap: '4px',
    width: '100%',
    backgroundColor: AUTH_COLORS.tabsBg,
    borderRadius: '8px',
};

export const authTabSx = (active) => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 36,
    px: '12px',
    py: '8px',
    borderRadius: '6px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: active ? '#FFFFFF' : 'transparent',
    boxShadow: active ? '0px 1px 4px rgba(0, 0, 0, 0.06)' : 'none',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: active ? 500 : 400,
    fontSize: 14,
    lineHeight: '130%',
    color: active ? AUTH_COLORS.primary : AUTH_COLORS.textSecondary,
    transition: 'all 0.15s ease',
});

export const authErrorSx = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '130%',
    color: AUTH_COLORS.error,
};

export const AUTH_CONSENT_FONT_SIZE = 14;
export const AUTH_CONSENT_LINE_HEIGHT = 1.3;
export const AUTH_CONSENT_CHECKBOX_SIZE = 16;

export const authConsentRowSx = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    m: 0,
    cursor: 'pointer',
    '& .MuiCheckbox-root': {
        p: 0,
        flexShrink: 0,
        width: AUTH_CONSENT_CHECKBOX_SIZE,
        height: AUTH_CONSENT_CHECKBOX_SIZE,
        mt: `${(AUTH_CONSENT_FONT_SIZE * AUTH_CONSENT_LINE_HEIGHT - AUTH_CONSENT_CHECKBOX_SIZE) / 2}px`,
        '& svg': {
            width: AUTH_CONSENT_CHECKBOX_SIZE,
            height: AUTH_CONSENT_CHECKBOX_SIZE,
        },
    },
};

export const authConsentSx = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: AUTH_CONSENT_FONT_SIZE,
    lineHeight: `${AUTH_CONSENT_LINE_HEIGHT * 100}%`,
    color: AUTH_COLORS.textSecondary,
    flex: 1,
    minWidth: 0,
};
